module.exports = __webpack_public_path__ + "static/media/5045_1100316020648_1190664_n.3c4ddbd2.jpg";